<div style="border: 1px solid #dddddd;" class="mb-5">
    <h2 style="padding: 10px;">{{lsNombre}} de {{ indexPagos }}</h2>
    <form id="{{lsNombre}}" class="flex-col p-3" [formGroup]="complementoPagoForm">
        <div class="row justify-content-start align-items-center">
            <div class="col-sm-12 col-md-2 col-xl-2">
                <mat-form-field class="inputFullWide">
                    <mat-label>Fecha de Pago</mat-label>
                    <input matInput [matDatepicker]="dpComplemento" format="yyyy-MM-dd" [disabled]='true' formControlName="fechaPago"
                        (dateChange)='changeFechaPago($event.target.value)'>
                    <mat-datepicker-toggle matSuffix [for]="dpComplemento">
                    </mat-datepicker-toggle>
                    <mat-datepicker #dpComplemento disabled="false"></mat-datepicker>
                    <mat-error> El campo es <strong>requerido</strong></mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-2 col-xl-2 ">
                <mat-form-field class="inputFullWide">
                    <mat-label></mat-label>
                    <input matInput formControlName="horaPago">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <mat-form-field appearance="fill">
                    <mat-label>Forma de Pago</mat-label>
                    <mat-select formControlName="formaPago" (selectionChange)="inhabilitar($event)">
                        <mat-option *ngFor="let formaPago of ltsFormaPago" [value]="formaPago">
                            {{formaPago.attributes.clave}} - {{formaPago.attributes.descripcion}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Monto(verificar el calculo)</mat-label>
                    <input matInput formControlName="montoPago" currencyMask>
                    <mat-hint>Debe introducirse el subtotal del documento a pagar</mat-hint>
                </mat-form-field>
            </div>
            <br>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <!-- <mat-form-field appearance="fill">
                    <mat-label>Moneda</mat-label>
                    <mat-select placeholder="MXN - Peso Mexicano" formControlName="monedaComplemento"
                        (selectionChange)="changeMoneda($event.value)">
                        <mat-option *ngFor="let moneda of ltsMoneda" [value]="moneda.id">
                            {{ moneda.attributes.clave }}-{{ moneda.attributes.descripcion }}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label style="font-size: 16px !important;" class="mb-5">Moneda</mat-label>
                    <input matInput aria-label="State" matInput formControlName="monedaComplemento"
                        [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="changeMoneda($event.value)"
                        [displayWith]="displayFn">
                        <mat-option *ngFor="let moneda of opcionesFiltradas | async"
                            [value]="moneda.id" style="height: 35px;">
                            <span>{{ moneda.attributes.clave }}-{{ moneda.attributes.descripcion }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

            </div>
            <div class="col-sm-12 col-md-4 col-xl-4">
                <mat-form-field appearance="fill">
                    <mat-label>Tipo de cambio <mat-icon class="mat-18" >info</mat-icon></mat-label>
                    <input matInput placeholder="Tipo de cambio respecto al peso" matTooltip="Se anota 1 cuando la factura original es igual a la Moneda del Complemento de Pago.
                    El campo “Tipo de Cambio” se debe de inhabilitar para captura cuando el campo “Moneda” de éste apartado es igual a “MXN Peso Mexicano”. "
                        formControlName="tipoCambioComplemento" oninput="this.value = this.value.toUpperCase()"
                        onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))">
                    <!-- <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('required')"><strong>*Este campo es obligatorio</strong></mat-error> -->
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Número de operación (opcional) <mat-icon class="mat-18" >info</mat-icon></mat-label>
                    <input matInput formControlName="numeroOperacion" matTooltip="Anote el número de referencia que identifique el pago ejemplo: No. de cheque, línea de captura, clave de rastreo etc.">
                </mat-form-field>
            </div>
            <br>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label matTooltip="Anote el RFC del banco por el que sale o se emite el pago.">RFC del Emisor cuenta ordenante (opcional)<mat-icon class="mat-18" >info</mat-icon> </mat-label>
                    <input matInput placeholder="RFC" formControlName="rfcCuentaOrdenante" matTooltip="Anote el RFC del banco por el que sale o se emite el pago.">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Cuenta Ordenante (opcional) <mat-icon class="mat-18" matTooltip="Cuenta bancaria de donde se emite el pago.">info</mat-icon></mat-label>
                    <input matInput formControlName="cuentaOrdenante" matTooltip="Cuenta bancaria de donde se emite el pago.">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Nombre del banco (opcional)</mat-label>
                    <input matInput formControlName="nombreBanco">
                </mat-form-field>
            </div>
            <br>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>RFC del Emisor Cuenta de Beneficiario (opcional)<mat-icon class="mat-18" matTooltip="RFC del banco receptor del pago.">info</mat-icon></mat-label>
                    <input matInput placeholder="RFC" formControlName="rfcCuentaBeneficiario" matTooltip="RFC del banco receptor del pago.">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 ">
                <mat-form-field class="inputFullWide">
                    <mat-label>Cuenta de Beneficiario (opcional)<mat-icon class="mat-18" matTooltip="Cuenta bancaria de recepción del pago.">info</mat-icon></mat-label>
                    <input matInput formControlName="cuentabeneficiario" matTooltip="Cuenta bancaria de recepción del pago.">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-4 col-xl-4 "></div>
        </div>
    </form>

    <div class="row flex-col p-3">
        <div class="col-sm-12 col-md-12 col-xl-12">
            <span class="lblDocRel">Documentos relacionados con el pago</span>
            <div class="row justify-content-start align-items-center">
                <div class="col-sm-1 col-md-1 col-xl-1">
                    <button (click)="addDocumentos()" class="fuse-mat-button-rounded" mat-flat-button>
                        <mat-icon>library_add</mat-icon>
                    </button>
                </div>
                <div class="col-sm-1 col-md-1 col-xl-1">
                    <button (click)="removeDocumentos()" class="fuse-mat-button-rounded" mat-flat-button>
                        <mat-icon>remove_from_queue</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row flex-col p-3">
        <div class="col-sm-12 col-md-12 col-xl-12">
            <app-docsRelacionados *ngFor="let docs of countDocsRel; let i=index" [ltsMoneda]="ltsMoneda"
                [ltsMetodoPago]="ltsMetodoPago" [ltsObjetoImpuesto]="ltsObjetoImpuesto"
                [lsNombre]="lsNombre" [countDocsRel]="countDocsRel.length" [docRel]="docs"
                [dataUpdateDocsRelacionados]="dataUpdateDocsRelacionados" [banderaActualizarFactura]="banderaActualizarFactura">
            </app-docsRelacionados>
        </div>
    </div>

</div>
<div style="width: 100%; height: 20px; background-color: lightgray;" class="mt-3 mb-3"></div>